export const TIMEOUT_MS = 5_000;
export const POLL_INTERVAL_MS = 100;
